export default __webpack_public_path__ + "static/media/demo-cartes.096f36d6.webm";